import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import "./Home.css";

const Acknowlaged = () => {
  let context = useAuth();
  let navigate = useNavigate();

  useEffect(() => {
    // signOut(auth);
  }, []);

  useEffect(() => {
    if (context && !context.myChannel && context.myInvites && context.myInvites.length > 0) {
      navigate("/dashboard/invitelist/");
    }
  }, [context]);

  return (
    <section>
      <div className="container">
        <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
          {/* Left Container */}
          <div className="flex flex-col items-start justify-start">
            <h1 className="herotitle">Skarvo</h1>
            <p className="text-xl font-normal"> Help us keep Skarvo safe, private, and secure for everyone.</p>
          </div>

          {/* Right Container */}
          <div className="flex flex-col gap-10">
            <div className="flex flex-col items-start formcard">
              <div className="flex flex-row items-start formheader">
                <div className="text-xl font-bold text-center">Sign Up</div>
              </div>
              <div className="thickseparator"></div>
              <p className="formexplainertext">
                Privacy and security are built into Skarvo from the moment you open the app and every time you use it. Keep your content respectful,
                high-quality, and safe for everyone.
              </p>
              <div className="thickseparator"></div>
              <p className="formexplainertext">
                By tapping Continue, you acknowledge that you have read and agree to our{" "}
                <Link to="https://www.skarvo.com/privacy" target="_blank" rel="noopener noreferrer" className="font-bold ">
                  Privacy Policy
                </Link>{" "}
                and{" "}
                <Link to="https://www.skarvo.com/terms" target="_blank" rel="noopener noreferrer" className="font-bold ">
                  Terms of Use
                </Link>
                .
              </p>

              <Link to="/signup" className=" w-button herobuttonsecondary">
                Continue
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Acknowlaged;
